






































// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import { useTranslate } from "@/plugins/translate";

const dockBtn = {
	props:[ "i", "t", "d", "v", "tv" ],
	template:`
	<button
	@click="!d ? $emit('click', $event) : () => {}"
	:disabled="d"
	class="btn dock-btn shadow"
	:class="'btn-' + v + ' text-' + tv"
	xv-b-tooltip="{
		disabled:d,
		title:t,
		interactive:false,
		delay:0,
		animation:false,
		variant:v,
		customClass:'font-nats font-weight-bold'
	}"
	>
		<span class="mdi"  :class="'mdi-' + i"></span>
	</button>
	`
};

export default defineComponent({
	props:{
		showBack: {
			type: Boolean,
			default: true,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		onLast: {
			type: Boolean,
			default: false,
		},
		open: {
			type: Boolean,
			default: true,
		},
	},
	components:{
		"dock-btn":dockBtn,
	},
	setup(props, context){
		const { translate } = useTranslate(context);
		const prevTitle = computed(() => translate("back").toUpperCase())
		const nextTitle = computed(() => translate("continue").toUpperCase());

		const toggleBtn = computed(() => {
			const icon = !props.open ? 'mdi.chevron-down' : 'mdi.chevron-up';
			return {
				icon,
				click(){
					context.emit("toggle");
				},
			};
		});


		return {
			prevTitle,
			nextTitle,
			toggleBtn,
		};
	}
});

